/**
 * @author sirisha.M
 * @description This Component is mainly for Creating AssetTypes
 */
import axios from 'axios';
import { connect } from 'react-redux';
import translation from '../Utils/translation';
import localStorage from '../../../utils/localStorage';
import StyledTable from '../../../commons/styles/table';
import React, { useState, useEffect, useRef } from 'react';
import { API_MODULES, IPAddress } from '../../../commons/api';
import {  DrawerFooter } from '../../../commons/styles/layout';
import { Form, Input, message, Button, Drawer, Tooltip, Upload, Select } from 'antd';
import { EditOutlined, PlusOutlined, DownloadOutlined, UploadOutlined } from '@ant-design/icons';
import {
  UpdateAssetTypeMaster,
  CreateAssetTypeMaster,
  getAssetTypeFileDownloadName
} from '../APICalls';


const ApiList = {
  CreateAssetType: `${API_MODULES.AssetTypesCreate}`,
  UpdateAssetType: `${API_MODULES.AssetTypesUpdate}`,
  assetTypesDropdown: '/api/rubusMaster/assetTypes/typeDropdown'
};

const AssetType = (props) => {
  const [formObject, setFormObject] = useState({});
  const [list, setList] = useState([]);
  const [visibleAttributes, setVisibleAttributes] = useState(false);
  const [assetTypeList, setAssetTypeList] = useState([]);
  const [fileDownloadName, setFileDownloadName] = useState('');
  const [translationCache, setTranslationCache] = useState(props.translationCache || []);
  const hForm = useRef(null);

  useEffect(() => {
    _getList();
    getFileDownloadName();
    _getAssetTypesList().then((assetTypes) => setAssetTypeList(assetTypes));
  }, []);

  useEffect(() => {
    if (props.translationCache !== translationCache) {
      setTranslationCache(props.translationCache);
    }
    // Handle translation cache updates if needed
  }, [translationCache]);



  const _getList = () => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const url = `/api/rubusMaster/assetTypes/get?SiteId=${siteId}`;

    axios
      .get(url, {
        headers: { Authorization: `Bearer ${accessToken}` }
      })
      .then((response) => setList(response.data))
      .catch((error) => console.error(error));
  };

  const _getAssetTypesList = async () => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const url = `/api/rubusMaster/assetTypes/typeDropdown?SiteId=${siteId}`;

    return axios
      .get(url, {
        headers: { Authorization: `Bearer ${accessToken}` }
      })
      .then((response) => response.data)
      .catch((error) => console.error(error));
  };

  const _editRecord = (record) => {
    hForm.current && hForm.current.setFieldsValue(record);
    setFormObject(record);
    setVisibleAttributes(true);
  };

  const onFinish = async () => {
    // try {
    hForm.current
      .validateFields()
      .then(async (values) => {
        values = {
          ...hForm.current.getFieldsValue()
        };
        const payload = { ...values };
        if (formObject && formObject.Id) {
          const updateResponse = await UpdateAssetTypeMaster(
            ApiList.UpdateAssetType,
            payload,
            formObject.Id
          );
          if (updateResponse?.status === 200) {
            message.success(updateResponse?.data?.message);
            getFileDownloadName();
          }
        } else {
          const createResponse = await CreateAssetTypeMaster(ApiList.CreateAssetType, payload);
          if (createResponse?.status === 200) {
            message.success(createResponse?.data?.message);
            getFileDownloadName();
          }
        }

        _getList();
        hForm.current && hForm.current.resetFields();
        setFormObject({});
        setVisibleAttributes(false);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const OpenDrawer = () => {
    hForm.current && hForm.current.resetFields();
    setFormObject({ Code: null, Name: null, Type: null });
    setVisibleAttributes(true);
  };

  const onClose = () => {
    hForm.current && hForm.current.resetFields();
    setVisibleAttributes(false);
    setFormObject({});
  };

  const getFileDownloadName = async () => {
    try {
      const fileData = await getAssetTypeFileDownloadName();
      setFileDownloadName(fileData?.file || '');
    } catch (error) {
      console.error(error);
    }
  };

  const OnNextClick = (record) => {
    props.navigate(`/rubus/CustomerAssetDevice/AssetParameter?AssetType=${record.AliasCode}`);
  };

  const columns = [
    { title: 'Code', dataIndex: 'Code', key: 'Code' },
    { title: 'Name', dataIndex: 'Name', key: 'Name' },
    { title: 'Asset Type', dataIndex: 'Type', key: 'Type' },
    {
      title: 'Action',
      dataIndex: 'Action',
      render: (text, record) => (
        <>
          <Button className="ant-btn" onClick={() => _editRecord(record)} >
            <Tooltip title="Edit">
              <EditOutlined />
            </Tooltip>
          </Button>
          <Button
            className="ant-btn"
            onClick={() => OnNextClick(record)}
            
            type="primary"
            style={{ marginLeft: '10px' }}
          >
            {translation(translationCache, 'Next')}
          </Button>
        </>
      )
    }
  ];

  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  const Authorization = `Bearer ${token}`;

  return (
    <div style={{ marginLeft: '17px', minHeight: window.innerHeight - 143 }}>
      <div style={{ display: 'flex', justifyContent: 'right', padding: '20px' }}>
        <Button>
          <a href={`${IPAddress.LOCAL}${fileDownloadName}`}>
            <DownloadOutlined style={{ color: 'white', marginRight: '1px' }} />
            <span style={{ color: 'white', marginRight: '10px' }}>{translation(translationCache, 'Download')}</span>
          </a>
        </Button>
        <Button>
          <Upload
            multiple={false}
            onChange={(info) => {
              if (info.file.status === 'done') {
                message.success(info.file.response.message);
                getFileDownloadName();
                _getList();
              } else if (info.file.status === 'error') {
                message.error(info.file.response.message);
              }
            }}
            action={`/api/rubusMaster/upload/assetType?SiteId=${siteId}`}
            headers={{ Authorization }}
            showUploadList={false}
          >
            <UploadOutlined style={{ color: 'white', marginRight: '1px' }} />
            <span style={{ color: 'white', marginRight: '10px' }}>{translation(translationCache, 'Upload')}</span>
          </Upload>
        </Button>
        <Button onClick={OpenDrawer}>
          <PlusOutlined /> {translation(translationCache, 'Add AssetType')}
        </Button>
      </div>

      <StyledTable size="small"
        columns={columns}
        dataSource={list}
        pagination={list.length > 10 ? { pageSize: '10' } : false}
      />

      <Drawer
        title={
          formObject && formObject.Id
            ? translation(translationCache, 'Update AssetType')
            : translation(translationCache, 'Add AssetType')
        }
        placement="right"
        width={600}
        closable
        onClose={onClose}
        open={visibleAttributes}
      >
        <Form
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 12 }}
          layout="horizontal"
          ref={hForm}
          name="Site_form"
          initialValues={formObject}
          onFinish={onFinish}
        >
          <Form.Item
            label={translation(translationCache, 'Code')}
            name="Code"
            rules={[{ required: true, message: translation(translationCache, 'Please enter Code !') }]}
          >
            <Input disabled={formObject && formObject.Id} placeholder={translation(translationCache, 'Please enter Code')} />
          </Form.Item>

          <Form.Item
            label={translation(translationCache, 'Name')}
            name="Name"
            rules={[{ required: true, message: translation(translationCache, 'Please enter Name !') }]}
          >
            <Input placeholder={translation(translationCache, 'Please enter Name')} />
          </Form.Item>

          <Form.Item
            label={translation(translationCache, 'Asset Type')}
            name="Type"
            rules={[{ required: true, message: translation(translationCache, 'Please select ModuleCode') }]}
          >
            <Select placeholder="Please select Asset Type">
              {assetTypeList &&
                Array.isArray(assetTypeList) &&
                assetTypeList.map((devicetype, index) => (
                  <Select.Option key={index} value={devicetype.value}>
                    {devicetype.key}
                  </Select.Option>
                ))}
            </Select>
          </Form.Item>
        </Form>

        <DrawerFooter>
          <Button onClick={onClose} style={{ marginRight: 8 }}>
            {translation(translationCache, 'Cancel')}
          </Button>

          <Button type="primary" onClick={onFinish}>
            {translation(translationCache, 'Submit')}
          </Button>
        </DrawerFooter>
      </Drawer>
    </div>
  );
};

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache

});
export default connect(mapStateToProps)(AssetType);

